/**
 * @fileoverview Página responsável pela visualização avançada de tickets em layout dedicado.
 */

import React, { useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles(theme => ({
    content: {
        overflow: "auto",
        height: "100%",
    }
}));

const TicketAdvanced = (props) => {
	const classes = useStyles();
	const { ticketId } = useParams();
    const history = useHistory();
    const { currentTicket, setCurrentTicket } = useContext(TicketsContext)

    useEffect(() => {
        if(currentTicket.id !== null) {
            setCurrentTicket({ id: currentTicket.id, code: '#open' })
        }
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!ticketId) return;
        const onKey = (e) => {
            if (e.key !== "Escape") return;
            const t = e.target;
            const typing =
                t?.isContentEditable ||
                ["INPUT", "TEXTAREA"].includes(t?.tagName);
            if (typing) return;
            if (document.querySelector(".MuiDialog-root")) return;
            history.push("/tickets");
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [ticketId, history]);

	const renderMessageContext = () => {
		return <Ticket />
	}

	const renderTicketsManagerTabs = () => {
		return <TicketsManagerTabs />
	}

	return (
        <TicketAdvancedLayout>
            <Box className={classes.content}>
                { ticketId ? renderMessageContext() : renderTicketsManagerTabs() }
            </Box>
        </TicketAdvancedLayout>
	);
};

export default TicketAdvanced;
